export const TRIGGER = {
    HOVER: 'hover',
    CLICK: 'click',
    FOCUS: 'focus',
};
